/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Select from "react-select";
import { default_pic_user } from "../assets";
import Utils from "../utility/utility";
import { STRING } from "../constants/string";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { USER_CREATE, USERGET_DATA, USER_UPDATE } from "../service/apiUrl";
import { postApiCall } from "../service/PostApiCall";
import { isEmpty } from "lodash";
import LoadingButton from "../components/LoadingButton";

/* Error slot. Always occupies its line so showing/hiding a message never
   changes layout height - the form does not jump when validation runs. */
const FieldError = ({ msg }) => (
  <span className={"field-error" + (msg ? " is-shown" : "")}>{msg || ""}</span>
);

const AddUser = (props) => {
  
  const [image, setImage] = useState({image : '', object :{}});
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [employeeData, setEmployeeData] = useState({});
  const [status, setStatus] = useState({ value: null, label: null });
  const [shift, setShift] = useState({ value: null, label: null });
  const [departments, setDepartments] = useState({ value: null, label: null });
  const [role, setRole] = useState({ value: null, label: null });
  const [teamlead, setTeamlead] = useState({ value: null, label: null });
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [contact, setContact] = useState("");
  // HR's label for the user (`user.employee_id`, printed on payslips) - not
  // the database id in the route, which never changes.
  const [empId, setEmpId] = useState("");
  const [helperData, setHelperData] = useState([]);
  const [passwordEye, setPasswordEye] = useState(false);
  const [passwordEyeSlash, setPasswordEyeSlash] = useState(false);
  const navigate = useNavigate();
  const signdata = useSelector((state) => state.signinReducers);
  const access_token = signdata?.data?.access_token;
  const { employee_id } = useParams();
  useEffect(() => {
    if (props.update) {
      setEmployeeData(props.employeeData);
    }
  }, [props.update]);

  // field-level validation errors, keyed by field name
  const [errors, setErrors] = useState({});
  // Clear a field's error as soon as its value becomes valid, so the message
  // and the red border disappear while the user types - they do not have to
  // submit again to see the error go away.
  useEffect(() => {
    setErrors((prev) => {
      if (!Object.keys(prev).length) return prev;   // nothing to clear
      const next = { ...prev };

      if (next.email && !Utils.isEmpty(email) && Utils.validateEmail(email))
        delete next.email;
      if (next.password && (props.update || !Utils.isEmpty(password)) &&
          (Utils.isEmpty(password) || password.length >= 6))
        delete next.password;
      if (next.confirmpassword && !Utils.isEmpty(confirmpassword) &&
          password === confirmpassword)
        delete next.confirmpassword;
      if (next.firstname && !Utils.isEmpty(firstname)) delete next.firstname;
      if (next.empId && !Utils.isEmpty(empId?.trim())) delete next.empId;
      if (next.role && !Utils.isEmpty(role.value)) delete next.role;
      if (next.status && !Utils.isEmpty(status.value)) delete next.status;
      if (next.shift && !Utils.isEmpty(shift.value)) delete next.shift;
      if (next.departments && !Utils.isEmpty(departments.value))
        delete next.departments;

      // keep the same object when nothing changed so React bails out
      return Object.keys(next).length === Object.keys(prev).length ? prev : next;
    });
  }, [email, password, confirmpassword, firstname, empId, role, status, shift,
      departments, props.update]);

  const objectdata = {
    uid: employee_id,
    tab: "user_info",
    email: email,
    password: password,
    updated_password: password,
    role: role.value,
    first_name: firstname,
    last_name: lastname,
    contact: contact,
    status: status.value,
    department: departments.value,
    shift: shift.value,
    team_lead: teamlead.value,
    image: image?.object,
    // new users get RS-<id> from the backend; only editing can change it
    ...(props.update && { employee_id: empId?.trim() }),
  };
  const validationuser = () => {
    // Collect every field error at once so the user sees all of them inline,
    // rather than one toast at a time for the first failure only.
    const e = {};

    if (Utils.isEmpty(email)) e.email = STRING.ENTER_EMAIL;
    else if (!Utils.validateEmail(email)) e.email = STRING.ENTER_VALID_EMAIL;

    if (!props.update && Utils.isEmpty(password)) e.password = STRING.ENTER_PASSWORD;
    else if (!Utils.isEmpty(password) && password.length < 6)
      e.password = STRING.ENTER_SIX_DIGIT_PASSWORD;

    if (!Utils.isEmpty(password) && Utils.isEmpty(confirmpassword))
      e.confirmpassword = STRING.ENTER_CONFIRM_PASSWORD;
    else if (password !== confirmpassword)
      e.confirmpassword = STRING.CONFIRM_PASSWORD;

    if (Utils.isEmpty(role.value)) e.role = STRING.ADMIN_ROLE;
    if (Utils.isEmpty(status.value)) e.status = STRING.STATUS;
    if (Utils.isEmpty(firstname)) e.firstname = STRING.FIRSTNAME;
    if (props.update && Utils.isEmpty(empId?.trim())) e.empId = STRING.EMPLOYEE_ID;
    if (Utils.isEmpty(shift.value)) e.shift = STRING.SHIFT;
    if (Utils.isEmpty(departments.value)) e.departments = STRING.DEPARTMENT;

    setErrors(e);
    let message = Object.keys(e).length ? "invalid" : "";

    if (message) {
      // errors render under their fields; no toast
      const first = document.querySelector(".is-invalid, .has-error");
      if (first && first.scrollIntoView)
        first.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    } else {
      if (props.update && !Utils.isEmpty(employee_id)) {
        if(Utils.isEmpty(password)){
          // delete objectdata.password;
        }
        return postApiCall(objectdata, access_token, USER_UPDATE,true).then((response) => {
          navigate("/manage-user");
        }).catch((error) => {
          // a taken employee ID belongs under its field, not on the button
          const msg = error?.data?.message;
          if (msg && /employee id/i.test(msg)) {
            setErrors({ empId: msg });
            return false;
          }
          throw error;
        });
      } else {
        return postApiCall(objectdata, access_token, USER_CREATE,true).then((response) => {
          navigate("/manage-user");
        });
      }
    }
  };
  useEffect(() => {
    postApiCall([], signdata?.data?.access_token, USERGET_DATA)
      .then((result) => {
        setHelperData(result);
      })
      .catch((error) => {
        console.error("USER_HELPER", error);
      });
  }, []);



  useEffect(() => {
    if (!isEmpty(employeeData)) {
      setEmail(employeeData?.email);
      setTeamlead(employeeData?.team_lead);
      setFirstname(employeeData?.first_name);
      setLastname(employeeData?.last_name);
      setContact(employeeData?.contact);
      setEmpId(employeeData?.employee_id ?? "");
      setStatus(employeeData?.status);
      setShift(employeeData?.shift);
      setDepartments(employeeData?.department);
      setRole(employeeData?.role);
      setImage({object:{},image:employeeData?.profile_pic ?? ""})
    }
  }, [employeeData]);

  return (
    <>
      <div
        className={
          props?.data?.transtion === true || props?.transtion === true
            ? "contents"
            : "content"
        }
      >
        <div
          className={props?.topbar_space === false ? "" : "content-top-spacer"}
        ></div>
        <div className="color-body">
          <div className="col-md-12  pading-none">
            <div className="mt-3">
              <h3> {props.update ? "" : "Add New User"} </h3>
            </div>
            <div className="row">
              <div className="col-md-6 manage pading-none">
                <div className="card-input mt-4 mb-2">
                  <div className="col-md-12">
                    <div className="mt-3">
                      <h5 className="border-bottom pb-2">Account Details</h5>
                    </div>
                    <form>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Email</label>
                            <input
                              type="text"
                              className={"form-control" + (errors.email ? " is-invalid" : "")}
                              value={email}
                              onChange={(email) => {
                                setEmail(email.target.value);
                              }}
                            />
                            <FieldError msg={errors.email} />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group" style={{position:'relative'}}>
                            <label htmlFor="exampleInputEmail1">Password</label>
                            <div className="input-with-eye">
                              <input
                              type={`${passwordEye=== true ? 'text':'Password'}`}
                              className={"form-control" + (errors.password ? " is-invalid" : "")}
                              placeholder="********"
                              autoComplete="off"
                              value={password}
                              onChange={(password) => {
                                setPassword(password.target.value);
                              }}
                            />
                              <span
                              className="password-eye"
                              onClick={() => setPasswordEye(!passwordEye)}
                            >
                              {passwordEye === true ? (
                                <i
                                  className="fa fa-eye-slash"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i className="fa fa-eye" aria-hidden="true"></i>
                              )}
                            </span>
                            </div>
                            <FieldError msg={errors.password} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-5">
                          <div className="form-group" style={{position:'relative'}}>
                            <label htmlFor="exampleInputEmail1">
                              Confirm Password
                            </label>
                            <div className="input-with-eye">
                              <input
                              type={`${passwordEyeSlash === true ? 'text':'Password'}`}
                              className={"form-control" + (errors.confirmpassword ? " is-invalid" : "")}
                              placeholder="********"
                              value={confirmpassword}
                              autoComplete="off"
                              onChange={(e) => {
                                setConfirmpassword(e.target.value);
                              }}
                            />
                              <span
                              className="password-eye"
                              onClick={() => setPasswordEyeSlash(!passwordEyeSlash)}
                            >
                              {passwordEyeSlash === true ? (
                                <i
                                  className="fa fa-eye-slash"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i className="fa fa-eye" aria-hidden="true"></i>
                              )}
                              </span>
                            </div>
                            <FieldError msg={errors.confirmpassword} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12"></div>
                    </form>
                  </div>
                </div>
                <div className="card-input mt-4 mb-2">
                  <div className="col-md-12">
                    <div className="mt-3">
                      <h5 className="border-bottom pb-2">Access Level</h5>
                    </div>
                    <div className="">
                      <div className="form-group">
                        <label>Roles</label>
                        <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                          options={helperData?.roles}
                          placeholder="Select Role"
                          value={role}
                          onChange={(event) => {
                            setRole({
                              value: event?.value,
                              label: event?.label,
                            });
                          }}
                        />
                          <FieldError msg={errors.role} />
                      </div>
                    </div>
                    <div className="">
                      <label>Team Lead</label>
                      <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                        options={helperData?.team_lead}
                        placeholder="Select Team Lead"
                        value={teamlead}
                        onChange={(event) => {
                          setTeamlead({
                            value: event?.value,
                            label: event?.label,
                          });
                        }}
                      />
                          <FieldError msg={errors.teamlead} />
                    </div>
                    <div className="mt-3 mb-5">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Status</label>

                        <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                          options={helperData?.status}
                          placeholder="Select Status"
                          value={status}
                          onChange={(event) => {
                            setStatus({
                              value: event?.value,
                              label: event?.label,
                            });
                          }}
                        />
                          <FieldError msg={errors.status} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="row mb-5 mt-3">
                    <div className="">
                      <LoadingButton
                        className="create-button"
                        successLabel={props.update ? "Saved" : "Created"}
                        onAction={validationuser}
                      >
                        {props.update ? "Update" : "Create"}
                      </LoadingButton>
                    </div>
                    <div className="ml-2">
                      <button
                        type="button"
                        className="create-button1 btn-info"
                        onClick={() => {
                            navigate("/manage-user");                          
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 manage">
                <div className="card-input mt-4 mb-2">
                  <div className="col-md-12">
                    <div className="mt-3">
                      <h5 className="border-bottom pb-2">
                        Personal Information
                      </h5>
                    </div>
                    {props.update && (
                      <div className="">
                        <div className="form-group">
                          <label htmlFor="employeeId">Employee ID</label>
                          <input
                            id="employeeId"
                            type="text"
                            maxLength={50}
                            className={"form-control" + (errors.empId ? " is-invalid" : "")}
                            value={empId}
                            onChange={(e) => {
                              setEmpId(e.target.value);
                            }}
                          />
                          <FieldError msg={errors.empId} />
                        </div>
                      </div>
                    )}
                    <div className="">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Firstname</label>
                        <input
                          type="text"
                          className={"form-control" + (errors.firstname ? " is-invalid" : "")}
                          value={firstname}
                          onChange={(name) => {
                            setFirstname(name.target.value);
                          }}
                        />
                            <FieldError msg={errors.firstname} />
                      </div>
                    </div>
                    <div className="">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Lastname</label>
                        <input
                          type="text"
                          className={"form-control" + (errors.lastname ? " is-invalid" : "")}
                          value={lastname}
                          onChange={(name) => {
                            setLastname(name.target.value);
                          }}
                        />
                            <FieldError msg={errors.lastname} />
                      </div>
                    </div>
                    <div className="">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Contact</label>
                        <input
                          type="text"
                          className={"form-control" + (errors.contact ? " is-invalid" : "")}
                          value={contact}
                          onChange={(contact) => {
                            setContact(contact.target.value);
                          }}
                        />
                            <FieldError msg={errors.contact} />
                      </div>
                    </div>
                    <div className="">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Shift</label>
                        <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                          options={helperData?.shifts}
                          placeholder="Select Shift"
                          value={shift}
                          onChange={(event) => {
                            setShift({
                              value: event?.value,
                              label: event?.label,
                            });
                          }}
                        />
                          <FieldError msg={errors.shift} />
                      </div>
                    </div>
                    <div className="">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Departments</label>
                        <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                          options={helperData?.departments}
                          placeholder="Select Department"
                          value={departments}
                          onChange={(event) => {
                            setDepartments({
                              value: event?.value,
                              label: event?.label,
                            });
                          }}
                        />
                          <FieldError msg={errors.departments} />
                      </div>
                    </div>
                    <div className="avatar-field">
                      <img
                        src={image?.image ? image.image : default_pic_user}
                        className="avatar-field-img"
                        alt=""
                      />
                      <div className="avatar-field-body">
                        <label htmlFor="filePicker" className="avatar-field-btn">
                          {image?.image ? "Change photo" : "Upload photo"}
                        </label>
                        <span className="avatar-field-hint">PNG, JPG or GIF</span>
                      </div>
                      <input
                        hidden
                        type="file"
                        id="filePicker"
                        accept="image/png, image/gif, image/jpeg"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) setImage({ object: file, image: URL.createObjectURL(file) });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUser;
